import { render, staticRenderFns } from "./index-brand.vue?vue&type=template&id=90490a68&scoped=true&"
import script from "./index-brand.vue?vue&type=script&lang=js&"
export * from "./index-brand.vue?vue&type=script&lang=js&"
import style0 from "./index-brand.vue?vue&type=style&index=0&id=90490a68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90490a68",
  null
  
)

export default component.exports